import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=395fcbe6&scoped=true"
import script from "./AgentList.vue?vue&type=script&lang=js"
export * from "./AgentList.vue?vue&type=script&lang=js"
import style0 from "./AgentList.vue?vue&type=style&index=0&id=395fcbe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395fcbe6",
  null
  
)

export default component.exports